export const recognitionTypes = {
  CORRECT_ON_LETTER: 'CORRECT_ON_LETTER',
  CORRECT_OFF_LETTER: 'CORRECT_OFF_LETTER',
  INCORRECT_ON_LETTER: 'INCORRECT_ON_LETTER',
  INCORRECT_OFF_LETTER: 'INCORRECT_OFF_LETTER',
}

export const keyboardKeys = {
  RIGHT_ARROW: 'ArrowRight',
  LEFT_ARROW: 'ArrowLeft',
  DOWN_ARROW: 'ArrowDown',
  SPACE: ' ',
  m: 'm',
  M: 'M',
  v: 'v',
  V: 'V',
  z: 'z',
  Z: 'Z',
}

export const consentTypes = {
  NON_STUDENT_PARTICIPANT: 'NON_STUDENT_PARTICIPANT',
  PSYCH1000_STUDENT: 'PSYCH1000_STUDENT',
}

export const blockTypes = {
  SURPRIZE_BLOCK: 'SURPRIZE_BLOCK',
  MEMORANDUM_BLOCK: 'Memorandum_Block',
  MIXED_BLOCK: 'MIXED_BLOCK',
}

export const binocularTrialTypes = {
  BINOCULAR_V1: 'BINOCULAR_V1',
  BINOCULAR_V2: 'BINOCULAR_V2',
  BINOCULAR_V3: 'BINOCULAR_V3',
}

export const borderColor = 'rgb(55, 55, 55)'
export const fontColor = 'rgb(95, 95, 95)'
export const cellColor = 'rgb(200, 200, 200)'
export const bullseyeOpacity = 35
export const inquiryBorderColor = 'darkred'

export const binocularPatchTypes = {
  RED: 'RED',
  GREEN: 'GREEN',
  MIXED: 'MIXED',
  FUSED: 'FUSED',
}

//experiment 4 consts
export const exp4BorderColor = 'rgb(200, 200, 200)'
